import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { MapIcon, Image as ImageIcon, CompassIcon } from 'lucide-react';
export function ContentPreview() {
  const items = ['El Jardín del Edén y Mesopotamia', 'La Ruta del Éxodo', 'El Tabernáculo en el Desierto', 'La Conquista de Canaán', 'Jerusalén en la época de David', 'El Templo de Salomón (3D)', 'Los Reinos Divididos', 'El Exilio en Babilonia', 'Tierra Santa en tiempos de Jesús', 'El Mar de Galilea', 'Jerusalén en el siglo I', 'Los Viajes Misioneros de Pablo', 'Las 7 Iglesias de Apocalipsis', 'Reconstrucciones 3D de Ciudades', 'Mapas Topográficos Detallados', 'Clima y Vegetación por Región', 'Rutas Comerciales Antiguas', 'Sitios Arqueológicos Verificados'];
  return <section className="py-12 bg-navy text-white" data-id="element-59">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-60">
        <FadeIn data-id="element-61">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-center text-white mb-8" data-id="element-62">
            Tipos de Contenido Visual Que Explorarás Hoy
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2.5 md:gap-3" data-id="element-63">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.03} data-id="element-64">
              <div className="flex items-center gap-3 p-3 rounded-lg bg-navy-800 border border-navy-700 hover:border-gold/50 transition-colors group" data-id="element-65">
                <div className="w-8 h-8 rounded-full bg-navy-900 flex items-center justify-center text-gold group-hover:scale-110 transition-transform flex-shrink-0" data-id="element-66">
                  {index % 3 === 0 ? <MapIcon className="w-4 h-4" data-id="element-67" /> : index % 3 === 1 ? <ImageIcon className="w-4 h-4" data-id="element-68" /> : <CompassIcon className="w-4 h-4" data-id="element-69" />}
                </div>
                <span className="font-medium text-sm text-gray-200" data-id="element-70">
                  {item}
                </span>
              </div>
            </FadeIn>)}

          <FadeIn delay={items.length * 0.03} data-id="element-71">
            <div className="flex items-center justify-center gap-4 p-3 rounded-lg bg-gold text-navy-900 font-bold text-lg shadow-[0_0_20px_rgba(201,168,76,0.3)]" data-id="element-72">
              ¡Y Mucho Más!
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}